"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceScope = void 0;
var ServiceScope;
(function (ServiceScope) {
    ServiceScope["API_GATEWAY"] = "API_GATEWAY";
    ServiceScope["PROVIDER_ADAPTER"] = "PROVIDER_ADAPTER";
    ServiceScope["PREDICTION_SERVICE"] = "PREDICTION_SERVICE";
})(ServiceScope || (exports.ServiceScope = ServiceScope = {}));
